/**
 * Shared onboarding logic — exported for testability.
 */

// kWh estimator table (Danish household consumption, 20% conservative)
export const KWH_TABLE: Record<string, Record<number, number>> = {
  apartment: { 1: 1300, 2: 1700, 3: 2050, 4: 2450, 5: 2800 },
  house: { 1: 2350, 2: 3000, 3: 3600, 4: 4150, 5: 4700 },
}

export function estimateKwh(persons: number, type: 'apartment' | 'house', hasElHeating: boolean, hasEV: boolean): number {
  const clamped = Math.min(Math.max(persons, 1), 5)
  const base = KWH_TABLE[type][clamped]
  const heating = hasElHeating ? (type === 'house' ? 4550 : 2800) : 0
  const ev = hasEV ? 2000 : 0
  return base + heating + ev
}

/** Category label in Danish */
export function getCategoryLabel(category: string): string {
  return category === 'energy' ? 'Strøm' : category === 'mobile' ? 'Mobil' : 'Internet'
}

/** Provider display name — falls back to category label if empty */
export function getProviderDisplay(provider: string | undefined | null, category: string): string {
  return provider || getCategoryLabel(category)
}
